module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Light-8464c78ea89fe48ea752ba930244f721.woff2";